import Sdk from "@modules/sdk/Sdk";
import { SdkRegisteredModuleInterface } from "@modules/sdk/SdkRegisteredModuleInterface";

import { CartRepositoryProvider } from "../services/CartRepositoryProvider";
import { CartSdkMethods } from "./CartSdkMethods";
import { CartHooksDefinitions } from "./hooks/CartSdkHooks";

class CartSdk implements SdkRegisteredModuleInterface {
    public readonly methods: CartSdkMethods;

    public readonly hooks = CartHooksDefinitions;

    constructor(cartRepositoryProvider: CartRepositoryProvider) {
        this.methods = new CartSdkMethods(cartRepositoryProvider);
    }

    public register(sdk: Sdk & { cart?: CartSdk }) {
        sdk.cart = this;
    }
}

export default CartSdk;
